export enum PaymentStatus {
  created = 'CREATED',
  processing = 'PROCESSING',
  paid = 'PAID',
  inAnalysis = 'IN_ANALYSIS',
  canceled = 'CANCELED',
  declined = 'DECLINED',
  disputeFinal = 'DISPUTE_FINAL',
  dispute = 'DISPUTE',
  partiallyRefunded = 'PARTIALLY_REFUNDED',
  refunded = 'REFUNDED',
  preAuthorized = 'PRE_AUTHORIZED',
  error = 'ERROR',
  disputeRecovered = 'DISPUTE_RECOVERED',
  postRefundDispute = 'POST_REFUND_DISPUTE',
  disputeRefund = 'DISPUTE_REFUNDED'
}
